<template>
    <div class="user-avatar">
        <div class="user-avatar__image" :style="{'background-image': `url(${avatar})`}"></div>

        <p>{{name}}</p>
    </div>
</template>

<script>
export default {
    name: 'UserAvatar',

    props: {
        name: {
            type: String,
            default: ''
        },
        avatar: {
            type: String,
            default: ''
        }
    }
}
</script>
